<block-ui></block-ui>

  <!--Begin::Section-->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0">
        <div class="card-title">
          <h3 *ngIf="!noLicenseFound" class="">{{Name}}</h3>
          <span *ngIf="!noLicenseFound" class="badge badge-light-success m-3 badge-lg">
            {{utilityService.getResourceValue("LicenseActivatedSuccessfully")}}
          </span>
        </div>

        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button type="button" class="btn btn-sm btn-primary" (click)="ShowUploadModal(UploadFileModal)">
            {{utilityService.getResourceValue("Activate")}}
          </button>
          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body d-flex align-items-center justify-content-center">
        <ng-container *ngIf="ShowTimer">
          <div class="main_Timer">
            <div class="clock">
              <div class="time row">
                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice text-center min-w-150px rounded">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Years")}}</div>
                    <span class="years fs-2hx fw-bolder text-gray-900">{{years}}</span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice text-center min-w-150px rounded">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Months")}}</div>
                    <span class="months fs-2hx fw-bolder text-gray-900">{{months}}</span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice text-center min-w-150px rounded">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Days")}}</div>
                    <span class="days fs-2hx fw-bolder text-gray-900">{{days}}</span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice text-center min-w-150px rounded d-none d-md-block">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Hours")}}</div>
                    <span class="hours fs-2hx fw-bolder text-gray-900">{{hours}}</span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice text-center min-w-150px rounded d-none d-md-block">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Minutes")}}</div>
                    <span class="min fs-2hx fw-bolder text-gray-900">{{minutes}}</span>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 mb-4 d-flex justify-content-center">
                  <div class="counter-item border bg-light-primary border-primary notice  text-center min-w-150px rounded d-none d-md-block">
                    <div class="counter-title fs-3 fw-bold text-primary d-block">{{utilityService.getResourceValue("Seconds")}}</div>
                    <span class="sec fs-2hx fw-bolder text-gray-900">{{seconds}}</span>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center license-head" *ngIf="noLicenseFound">
            <h3 class="text-danger">
              {{utilityService.getResourceValue("LicenseNotFound")}}
            </h3>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!noLicenseFound" class="card-footer border-0 d-flex justify-content-between">
        <div class="mb-4">
          <span class="badge badge-light-primary fs-7 fw-bolder me-2 min-w-150px">{{utilityService.getResourceValue("LicenseStartDate")}}:</span>
          <span class="font-weight-500">{{LicenseStartDate | date:'dd-MM-y'}}</span>
        </div>
        <div>
          <span class="badge badge-light-danger fs-7 fw-bolder me-2 min-w-150px">{{utilityService.getResourceValue("LicenseExpiryDate")}}:</span>
          <span class="font-weight-500">{{LicenseEndDate | date:'dd-MM-y'}}</span>
        </div>
      </div>
    </div>

  </div>


  <!-- activate-->
  <ng-template #UploadFileModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'.././src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3"> {{utilityService.getResourceValue("UploadLicense")}}</h1>
      </div>
      <form [formGroup]="UploadFileForm">
        <BBSF-FileUplaod [options]="LicenseFileInput" [group]="UploadFileForm">
        </BBSF-FileUplaod>
        <div class="text-center pt-7">
          <button #CloseLicenseFileModal id="CloseLicenseFileModal" type="button" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="button" (click)="UploadFiles(false)" class="btn btn-light-primary me-3 btn-sm">{{utilityService.getResourceValue("Replace")}}</button>
          <button type="button" (click)="UploadFiles(true)" class="btn btn-primary me-3 btn-sm">{{utilityService.getResourceValue("Append")}}</button>

        </div>
      </form>
    </div>
  </ng-template>


